import { combineReducers } from "redux";
import authReducer from "./authReducer";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";
import profileReducer from "./profileReducer";
import regionReducer from "./regionReducer";
import airtimeReducer from "./airtimeReducer";
import adcardReducer from "./adcardReducer";
import transactionReducer from "./transactionReducer";

export default combineReducers({
  auth: authReducer,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  profile: profileReducer,
  region: regionReducer,
  airtime: airtimeReducer,
  adcard: adcardReducer,
  transaction: transactionReducer,
});
